<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="scss">
@import "sass/main.scss";
@import "styles/core.scss";
</style>
